export default {
	section: {
		marginTop: 15,
	},
};
